import { render, staticRenderFns } from "./PortfolioUpcomingEvents.vue?vue&type=template&id=b83a07c6&scoped=true&"
import script from "./PortfolioUpcomingEvents.vue?vue&type=script&lang=js&"
export * from "./PortfolioUpcomingEvents.vue?vue&type=script&lang=js&"
import style0 from "./PortfolioUpcomingEvents.vue?vue&type=style&index=0&id=b83a07c6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b83a07c6",
  null
  
)

export default component.exports